/** Opens http(s) links in a new tab; `mailto:`, `tel:` and relative links keep the default behavior */
export const externalLinkProps = (href?: string) =>
  href && /^https?:\/\//i.test(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {}
